// ResourceModal already accepts resource HTML. Parse it inertly so the narrow
// embed override exists in the markup before v-html can insert/load any frame.
export function prepareResourceBody(body) {
    if (!body) return body;
    const template = document.createElement('template');
    template.innerHTML = body;
    let changed = false;
    template.content.querySelectorAll('iframe[src]').forEach(frame => {
        if (frame.namespaceURI === 'http://www.w3.org/1999/xhtml' && !frame.hasAttribute('srcdoc') && isTrustedYouTubeEmbed(frame.getAttribute('src'))) {
            frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
            changed = true;
        }
    });
    return changed ? template.innerHTML : body;
}

export function isTrustedYouTubeEmbed(src) {
    if (typeof src !== 'string' || !/^https:\/\//i.test(src) || /[\\\u0000-\u0020\u007f]/.test(src)) return false;
    try {
        const url = new URL(src);
        return url.protocol === 'https:' && !url.username && !url.password && !url.port &&
            ['www.youtube.com', 'youtube.com', 'www.youtube-nocookie.com', 'youtube-nocookie.com'].includes(url.hostname) &&
            /^\/embed\/[a-zA-Z0-9_-]+\/?$/.test(url.pathname);
    } catch {
        return false;
    }
}
